import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import DataTable from "../../utils/DataTable";
import Info from "../../utils/Alert/Info";
import DateTimeHelpers from "helpers/DateTimeHelpers";
// import Button from "@mui/material/Button";
// import PrinterImg from "images/svg/printer.svg";
// import ExportIcon from "images/svg/export.svg";
import { roundOff, customerAmountFormat } from "helpers/NumberFormatHelper";

export default function ShiftPaymentCashBookPopup(props) {
  const { toggleViewCashBook, rowData } = props;

  const listHeader = [
    {
      id: "time",
      label: "Time",
      type: "callback",
      width: "200px",
      viewRender: (item) => {
        return DateTimeHelpers.formatDateAndTime(item.time);
      },
    },
    {
      id: "description",
      label: "Description",
      type: "text",
    },
    {
      id: "credit",
      label: "In",
      type: "callback",
      width: "100px",
      viewRender: (item) => roundOff(item.credit || 0),
    },
    {
      id: "debit",
      label: "Out",
      type: "callback",
      width: "100px",
      viewRender: (item) => roundOff(item.debit || 0),
    },
    {
      id: "balance",
      label: "Balance",
      type: "callback",
      width: "100px",
      viewRender: (item) => customerAmountFormat(item.balance || 0),
    },
  ];

  // const handlePrint = async () => {
  //   console.log("print");
  // };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{`${rowData?.summary?.payment} Book`}</h2>
          <div className={styles.actionSection}>
            <div className={styles.buttonBar}>
              {/* <Button
                className={`${styles.button} ${styles.exportBtn}`}
                startIcon={<img src={ExportIcon} alt="Export" className={styles.iconSmall} />}
              >
                Export
              </Button>
              <Button
                className={`${styles.button} ${styles.printBtn}`}
                onClick={handlePrint}
                startIcon={<img src={PrinterImg} alt="Print" className={styles.iconSmall} />}
              >
                Print
              </Button> */}
            </div>

            <CloseIcon
              style={{ color: "rgba(124, 124, 125, 1)", cursor: "pointer" }}
              onClick={() => {
                toggleViewCashBook(null);
              }}
            />
          </div>
        </div>
        <div className={styles.tableContent}>
          {rowData.tnx ? (
            <div id="cashBookTable">
              <DataTable columns={listHeader} rows={rowData.tnx} />
            </div>
          ) : (
            <Info title={"Cash Book Details not found"} content={"This cash book have no transaction to list up"} />
          )}
        </div>
      </div>
    </div>
  );
}
